import { useCallback, useState } from 'react';

interface ExpandedItemGroups {
  isItemExpanded: (itemUUID: string) => boolean;
  toggleItemExpanded: (itemUUID: string) => void;
}

/**
 * Tracks expanded grouped rows by item UUID. Held above the rows so a row's
 * expand state survives the drag portal remounting it.
 */
export const useExpandedItemGroups = (): ExpandedItemGroups => {
  const [expanded, setExpanded] = useState<ReadonlySet<string>>(
    () => new Set(),
  );

  const toggleItemExpanded = useCallback((itemUUID: string) => {
    setExpanded((previous) => {
      const next = new Set(previous);
      if (next.has(itemUUID)) {
        next.delete(itemUUID);
      } else {
        next.add(itemUUID);
      }
      return next;
    });
  }, []);

  const isItemExpanded = useCallback(
    (itemUUID: string) => expanded.has(itemUUID),
    [expanded],
  );

  return { isItemExpanded, toggleItemExpanded };
};
